import {SListTabs} from "shj-components";
import Workload from "@/pages/callTool/outboundCallAnalysis/list/workload";
import CallMonitoring from "@/pages/callTool/outboundCallAnalysis/list/callMonitoring";

function OutboundCallAnalysis() {
  
  const items = [
    {
      label: '外呼工作量',
      key: 'workload',
      children: <Workload />,
    },
    {
      label: '通话监控',
      key: 'monitor',
      children: <CallMonitoring />,
    }
  ]
  
  return <SListTabs items={items} auth={false}/>
}

export default OutboundCallAnalysis